__turbopack_context__.v({
  "buttonRowsWrapper": "HeroCategories-module__PMGOua__buttonRowsWrapper",
  "content": "HeroCategories-module__PMGOua__content",
  "root": "HeroCategories-module__PMGOua__root",
  "scrollButton": "HeroCategories-module__PMGOua__scrollButton",
});
